import React, { useEffect, useState } from "react";
import PrivateApi from "../../services/PrivateApiService";
import { Col, Container, Row } from "react-bootstrap";
import BuildingComponent from "../../components/hw/BuildingComponent";
import { useParams } from "react-router-dom";
import SplashPage from "../SplashPage";
import InvoiceTable from "../../components/invoice/InvoiceTable/InvoiceTable";
import { useQuery } from "react-query";
import EnergoTooltip from "../../components/shared/EnergoTooltip";

/**
 * InvoicePage
 * 
 * displays invoices for selected building and has posibility to download them in zip files
 * 
 * @returns none
 */
const InvoicePage = () => {

    const API = new PrivateApi(); // API calls
    const { building_id } = useParams(); // building parameter passed from BuildingPage
    const [selectedAnlageId, setSelectedAnlageId] = useState([]); // array state for selected (clicked) Anlage
    const [selectedInvoices, setSelectedInvoices] = useState([]); // array state for filtered Invoices

    const [building, setBuilding] = useState(); // object state for building
    const [anlagen, setAnlagen] = useState([]); // array state for Anlagen
    const [invoices, setInvoices] = useState([]); // initial array of Invoices


    const { data, error, isLoading } = useQuery(["GET_BUILDING_INVOICES", building_id], () => API.hw_InvoicesBuilding(building_id), {
        enabled: building_id !== undefined,
        staleTime: Infinity,
        onSuccess: (data) => {
            var res = data.data;
            setBuilding(res.building);
            setAnlagen(res.anlagen);

            const sortedInvoices = [
                ...res.poolrechnungen,
                ...res.abrechnungen,
                ...res.vorschreibungen
            ].sort((a, b) => new Date(b.create_date) - new Date(a.create_date));

            setInvoices(sortedInvoices);
            setSelectedInvoices(sortedInvoices);
        }
    })


    if (isLoading) return <SplashPage />
    if (error) return <SplashPage error={error} />

    // GUI
    return (
        <Container>
            <Row className="text-start mb-5">
                <Col>
                    <div style={{display: "flex"}}>
                        <h3 style={{marginRight: 10}}>Dokumente</h3>
                        <EnergoTooltip tKey="4001" position="right" />
                    </div>
                    <p className="text-muted">{building ? building.name : 'Ihre Abrechnungen bei ENERGO'}</p>
                </Col>
            </Row>
            <Row>
                <BuildingComponent selected={selectedAnlageId} setSelected={setSelectedAnlageId} building={building} anlagen={anlagen} />
            </Row>
            <Row>
                <Col>

                </Col>
            </Row>

            <Row>
                <Col>
                    <InvoiceTable 
                        allInvoices={[
                            ...data.data.poolrechnungen,
                            ...data.data.abrechnungen,
                            ...data.data.vorschreibungen
                        ].sort((a, b) => new Date(b.create_date) - new Date(a.create_date))}
                        selectedAnlage={selectedAnlageId}
                        />
                </Col>
            </Row>
        </Container>
    )
}

export default InvoicePage;